
import { mapGetters, mapActions } from "vuex"
import { getSessionDurationSec } from "@/utils/_"

export default {
  props: {
    session: { type: Object, required: true },
    dayStart: { type: Number, required: true },
    pxPerSec: { type: Number, required: true },
    tracksWidth: { type: Number, required: true },
  },

  data: () => ({
    isMounted: false,
  }),

  computed: {
    ...mapGetters("user", ["favoriteSessions", "isAdmin"]),

    isFavorite () {
      return this.$store.getters["user/isSessionFavorite"](this.session)
    },

    height () {
      return this.pxPerSec * getSessionDurationSec(this.session)
    },
    top () {
      return this.pxPerSec * (this.session.start - this.dayStart) / 1000
    },
  },

  mounted () {
    this.isMounted = true
  },

  methods: {
    ...mapActions("user", ["setFavoriteSession"]),

    async toggleFavorite () {
      if (!this.$auth.loggedIn)
        return this.$router.push(this.localePath("/login"))

      await this.setFavoriteSession({
        alias: this.session.alias, isFavorite: !this.isFavorite,
      })
    },
  },
}
